<template>
  <div>
    <div class="flex fdr">
      <el-select class="filter__input" size="mini" v-model="localValue" filterable placeholder="不需要不用选" @change="$emit('input', $event)">
        <el-option :label="item.label" :value="item.value" v-for="(item, index) in lists" :key="index"></el-option>
      </el-select>
      <div class="ml-10" v-if="needEdit">
        <el-button size="mini" @click="initDetail(true)">添加发票抬头</el-button>
      </div>
      </div>
    <el-dialog title="对接方编辑" :visible.sync="editDialog" size="tiny" width="800px" center>
     <el-form ref="form" :model="detail" label-width="80px">
        <el-form-item label="ID">
          <el-input v-model="detail.itid" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="发票抬头名称">
          <el-input v-model="detail.name"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号">
          <el-input v-model="detail.tax_no"></el-input>
        </el-form-item>
        <el-form-item label="企业类型">
          <el-radio-group v-model="detail.company_type">
            <div class="dib mr-20">
              <el-radio :label="1">一般纳税人</el-radio>
              <el-radio :label="2">小规模纳税人</el-radio>
              <el-radio :label="3">个体户</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发票类型">
          <el-radio-group v-model="detail.invoice_type">
            <div class="dib mr-20">
              <el-radio :label="1">普票</el-radio>
              <el-radio :label="2">专票</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="detail.address"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="detail.phone"></el-input>
        </el-form-item>
        <el-form-item label="开户银行">
          <el-input v-model="detail.bank_name"></el-input>
        </el-form-item>
        <el-form-item label="银行账号">
          <el-input v-model="detail.bank_account"></el-input>
        </el-form-item>
        <div class="flex jcc mt-30">
          <div class="blue-large-btn mr-20" @click="detailEdit">保存</div>
          <div class="gray-large-btn" @click="editDialog = false">取消</div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import util from '../../script/util'
import {invoiceTitleLists, invoiceTitleEdit} from '../../api/api'
export default {
  props: {
    value: { // v-model 必须使用value名字
      required: true, // 必须传递该属性
      default: '' // 未传值时的默认值
    },
    needEdit: {
      type: Boolean, // 必须为字符串
      default: false // 未传值时的默认值
    }
  },
  data () {
    return {
      localValue: this.value,
      lists: [],
      editDialog: false,
      detail: {
        itid: 0,
        name: '',
        tax_no: '',
        address: '',
        phone: '',
        bank_name: '',
        bank_account: '',
        company_type: 2,
        invoice_type: 1,
      }
    }
  },
  methods: {
    initValue () {
      this.localValue = this.value
    },
    initDetail (editDialog) {
      for (let key in this.detail) {
        this.detail[key] = ''
      }
      this.detail.itid = 0
      this.detail.company_type = 2
      this.detail.invoice_type = 1
      this.editDialog = editDialog
    },
    detailEdit () {
      let params = util.cloneObj(this.detail)

      let content = ''

      if (params['name'] === '') {
        content = '发票抬头不能为空'
      }

      if (params['tax_no'] === '') {
        content = '纳税人识别号不能为空'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      invoiceTitleEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.initDetail(false)

          this.getLists()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getLists () {
      let params = {
        l: 1000,
        p: 1
      }
      invoiceTitleLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists.map((item, index) => {
            return {
              label: item.name,
              value: item.itid
            }
          })
          if (this.needEdit === false) {
            this.lists.unshift({
              label: '所有',
              value: ''
            })
          }
        }
      })
    }
  },
  mounted () {
    this.getLists()
  },
  watch: {
    'value': 'initValue'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/data-select/invoiceTitleSelect.vue